module.exports = __webpack_public_path__ + "img/base_divers_marches.ea135fc3.svg";